export default class SpecialistEveryoneController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/specialistEveryone/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/startOnly/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/startWithBusinessKey/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/startAndTakeUserTask/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/startAndSaveDraft/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/submitUserTask/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/viewTaskBusinessData/flowSpecialistEveryAudit', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/viewHistoricTaskBusinessData/flowSpecialistEveryAudit', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowSpecialistEveryAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/listWorkOrder/flowSpecialistEveryAudit', 'post', params, axiosOption, httpOption);
  }

  static checkApply (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistEveryone/checkApply', 'post', params, axiosOption, httpOption);
  }
}
